export default {
  nav: {
    home: 'Головна',
    manufacturers: 'Виробники',
    products: 'Каталог',
    about: 'Про нас',
    blog: 'Блог',
    faq: 'Часті питання',
    contact: 'Контакти',
    getQuote: 'Надіслати запит',
  },
  langModal: {
    title: 'Ми по всьому світу',
    chooseLocation: 'Оберіть свою локацію',
  },
  header: {
    email: "webenquiries{'@'}gmgautomation.net",
    phone: '+39 040 957 1062',
    language: 'Українська',
    searchPlaceholder: 'Пошук за номером деталі або виробником',
    noResults: 'Деталі не знайдено',
    enquiryLink: 'Відправити запит',
    enquiryLinkSub: "Не можете знайти потрібну деталь? Зв'яжіться з нами",
  },
  quoteDrawer: {
    title: 'Надіслати запит',
    parts: 'Номер деталі',
    addPart: 'Додати деталь',
  },
  home: {
    hero: {
      title: 'Шукайте деталі за номером і знаходьте {highlight} та сучасні запчастини для автоматизації',
      highlight: 'зняті з виробництва',
      subtitle:
        'Ознайомтеся з нашим широким асортиментом деталей для будь-яких потреб: контролери, ПЛК, HMI-панелі, двигуни, енкодери, сервоприводи, інвертори, системи ЧПК та багато іншого',
      searchPlaceholder: 'Введіть номер деталі...',
      search: 'Пошук',
    },
    manufacturers: {
      title: 'Виробники',
      subtitle:
        'Наш широкий асортимент налічує тисячі компонентів автоматизації та керування від провідних OEM-виробників, що робить нас універсальним рішенням для ваших потреб. Якщо потрібної деталі немає в наявності, наша багатомовна команда знайде її по всьому світу та запропонує найвигіднішу ціну.',
      viewProducts: 'Переглянути каталог',
      viewAll: 'Переглянути весь каталог',
    },
    whyUs: {
      title: 'Чому GMG Automation?',
      subtitle: 'Цінності, які роблять нас надійним партнером у промисловій автоматизації',
      quality: {
        title: 'Якісний сервіс',
        description: 'Кожна деталь ретельно перевіряється перед відправкою для забезпечення надійної роботи.',
      },
      shipping: {
        title: 'Швидка доставка',
        description: 'Експрес-доставка по всьому світу — мінімальний простій вашого виробництва.',
      },
      warranty: {
        title: 'Гарантія 12 місяців',
        description: 'Кожна деталь постачається з гарантією 12 місяців для повного спокою.',
      },
    },
    services: {
      title: 'Послуги',
      subtitle: 'Комплексні рішення для ваших потреб у запасних частинах для автоматизації',
      learnMore: 'Дізнатися більше',
      supply: {
        title: 'Постачання',
        description:
          'Ми подбаємо про доставку вашої деталі з нашого складу або безпосередньо від постачальника прямо до ваших дверей.',
      },
      exchange: {
        title: 'Сервісний обмін',
        description:
          'Ми приймемо ваш несправний пристрій в обмін на протестований та повністю робочий пристрій зі значною знижкою.',
      },
      repair: {
        title: 'Ремонт',
        description: 'Ми можемо відремонтувати тисячі деталей за фіксованими цінами.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Пошук виробників...',
    noResults: 'Виробників не знайдено',
    hero: {
      title: 'Виробники',
      subtitle: 'Ознайомтеся з нашим широким переліком виробників і перевірте наявність тисяч деталей',
      badges: {
        warranty: { title: 'Гарантія 12 місяців', subtitle: 'На всі поставлені деталі' },
        response: { title: 'Швидка відповідь', subtitle: 'Протягом 24 годин' },
        delivery: { title: 'Глобальна доставка', subtitle: 'Доставка по всьому світу' },
      },
    },
    products: {
      hero: {
        subtitle: 'Не можете знайти потрібну деталь? Зателефонуйте нам або надішліть запит',
      },
      searchPlaceholder: 'Пошук за номером деталі...',
      showingEntries: 'Показано {from}–{to} з {total} деталей',
      noResults: 'Деталей не знайдено',
    },
  },
  about: {
    hero: {
      title: 'Наша мета',
      subtitle:
        'Знаходити рішення з постачання запчастин для автоматизації, щоб мінімізувати простої та довгі строки очікування від OEM-виробників',
    },
    values: {
      fast: {
        title: 'Швидко',
        desc: 'Ми відомі швидкою відповіддю та оперативно реагуємо на потреби клієнтів, щоб ваші системи автоматизації поверталися до максимальної продуктивності з мінімальною затримкою.',
      },
      friendly: {
        title: 'Зручно',
        desc: 'Отримайте простий і приємний сервіс від нашої уважної команди, яка готова допомогти на кожному етапі та зробити співпрацю з нами максимально комфортною.',
      },
      experienced: {
        title: 'Професійно',
        desc: 'Завдяки багаторічному досвіду в галузі ми надаємо професійні консультації та якісні рішення, залишаючись вашим надійним партнером у постачанні запчастин для автоматизації.',
      },
      reliable: {
        title: 'Надійно',
        desc: 'Надійність лежить в основі нашої роботи. Ми пропонуємо перевірені рішення для постачання запчастин для автоматизації, яким можна довіряти щоразу.',
      },
    },
    story1: {
      title: 'Наша команда розуміє потреби галузі',
      text: 'GMG Automation уважно ставиться до потреб клієнтів, які шукають рішення у разі поломки обладнання або потребують застарілих запчастин. Саме тому ми створили глобальну мережу постачальників, щоб пропонувати швидкі та економічно вигідні рішення.',
    },
    story2: {
      title: 'Створюємо надійний сервіс для кожного клієнта',
      text: 'Маючи понад 10 років досвіду в галузі автоматизації та багатомовну команду, ми не залишимо вас сам на сам із проблемою.',
    },
  },
  blog: {
    hero: {
      title: 'Блог',
      subtitle: 'Будьте в курсі останніх новин та матеріалів від нашої команди',
    },
    empty: 'Статей не знайдено.',
    back: 'Назад до блогу',
    label: 'Стаття',
    related: 'Інші статті',
  },
  faq: {
    hero: {
      title: 'Часті запитання',
      subtitle: 'Ознайомтеся з нашими поширеними запитаннями',
    },
    search: 'Пошук частих питань',
    empty: 'Частих питань не знайдено.',
  },
  contact: {
    hero: {
      title: "Зв'яжіться з нами",
      subtitle:
        'У GMG Automation ми є не просто постачальники запасних частин для автоматизації, ми є ваші надійні партнери на шляху до успіху. Наша віддана багатомовна команда готова допомогти вам з будь-якими запитами',
    },
    offices: {
      title: 'Наші офіси',
    },
    form: {
      title: "Зв'язатися з нами",
      name: "Ім'я",
      company: 'Назва компанії',
      email: 'Електронна пошта',
      nameRequired: "Ім'я є обов'язковим.",
      companyRequired: "Назва компанії є обов'язковою.",
      emailRequired: "Електронна пошта є обов'язковою.",
      phoneRequired: "Номер телефону є обов'язковим.",
      phone: 'Номер телефону',
      phonePlaceholder: 'Напр., +380 50 123 45 67',
      message: 'Будь ласка, опишіть деталі',
      send: 'Надіслати',
      sending: 'Надсилання...',
      successTitle: 'Повідомлення надіслано',
      successDetail: "Ми зв'яжемося з вами якомога швидше.",
      errorTitle: 'Помилка',
      errorDetail: 'Щось пішло не так. Будь ласка, спробуйте ще раз.',
    },
    plantAddresses: {
      title: 'Адреси та банківські реквізити',
      regNumber: 'Реєстраційний номер компанії',
      phone: 'Телефон',
      bankDetails: 'Банківські реквізити',
      beneficiary: 'Отримувач',
    },
  },
  terms: {
    hero: {
      title: 'Умови користування',
    },
    empty: 'Умови користування не знайдено.',
  },
  privacy: {
    hero: {
      title: 'Політика конфіденційності',
    },
    empty: 'Політику конфіденційності не знайдено.',
  },
  cookie: {
    hero: { title: 'Політика Cookie' },
    empty: 'Політику Cookie не знайдено.',
    banner: {
      message:
        'Ми використовуємо файли cookie для покращення вашого досвіду на сайті. Продовжуючи перегляд, ви погоджуєтесь з використанням cookie.',
      learnMore: 'Політика Cookie',
      necessaryOnly: 'Лише необхідні',
      acceptAll: 'Прийняти всі',
    },
  },

  product: {
    manufacturer: 'Виробник',
    partNumberLabel: 'Номер деталі',
    noDescription: 'Опис відсутній',
    inStock: 'В наявності',
    available: 'Доступно',
    qty: 'Кількість',
    addToCart: 'Додати до кошика',
    addedToCart: 'Додано до кошика',
    enquiryTitle: 'Швидкий запит',
    warrantyText: 'Усі деталі постачаються зі стандартною гарантією 12 місяців.',
    fetchError: 'Не вдалося завантажити деталь.',
    trust: {
      warranty: 'Гарантія 12 місяців на всі деталі',
      shipping: 'Швидка доставка по всьому світу',
      support: 'Професійна служба підтримки',
    },
    features: {
      quality: 'Висока якість',
      delivery: 'Швидка доставка',
      warranty: 'Гарантія 12 місяців',
    },
    tabs: {
      description: 'Опис',
      warranty: 'Гарантія',
    },
  },

  enquiryForm: {
    companyName: 'Назва компанії',
    yourName: 'Ваше імʼя',
    email: 'Електронна пошта',
    country: 'Оберіть країну',
    partNumber: 'Номер деталі',
    quantity: 'Кількість',
    send: 'Надіслати',
    phoneInput: {
      placeholder: 'Телефон',
      searchPlaceholder: 'Пошук',
    },
    successTitle: 'Запит надіслано',
    successDetail: "Ми зв'яжемося з вами найближчим часом.",
    errorTitle: 'Щось пішло не так',
    errorDetail: 'Будь ласка, спробуйте ще раз пізніше.',
  },

  cart: {
    title: 'Кошик',
    empty: 'Тут поки що порожньо',
    emptySub: 'Додавайте деталі зі сторінок товарів',
    browse: 'Переглянути деталі',
    itemCount: '{count} деталь | {count} деталі | {count} деталей',
    partNumber: 'Номер деталі',
    availability: 'Доступність',
    quantity: 'Кількість',
    clearAll: 'Очистити все',
    clearTitle: 'Очистити кошик',
    clearConfirm: 'Ви впевнені, що хочете видалити всі деталі з кошика?',
    clear: 'Очистити',
    cancel: 'Скасувати',
    enquirySubtitle: '{count} деталь у запиті | {count} деталі у запиті | {count} деталей у запиті',
    addedTitle: 'Додано до кошика',
    addedDetail: '{partNumber} додано до кошика запитів',
  },

  searchEnquiry: {
    title: 'Результати пошуку для',
    whatNext: {
      title: 'Що відбувається далі?',
      step1Title: '1. Підтвердження електронною поштою',
      step1Text: 'Ви отримаєте електронний лист із підтвердженням того, що ми отримали ваш запит.',
      step2Title: '2. Персональний менеджер',
      step2Text:
        'Один із наших фахівців зв’яжеться з вами, щоб уточнити деталі вашого запиту та стан потрібної деталі.',
      step3Title: '3. Ваша комерційна пропозиція',
      step3Text: 'Після уточнення всіх деталей ми підготуємо для вас індивідуальний розрахунок.',
      legal: 'Усі замовлення залежать від наявності товару.',
      legalLink: 'Переглянути умови та положення.',
      askTeam: 'Запитайте нашу команду',
      emailLabel: 'Електронна пошта',
    },
  },

  footer: {
    contact: {
      title: 'Більше способів зв’язатися з нами',
      subtitle: 'Зателефонуйте нам або заповніть форму — ми з радістю вам допоможемо!',
      formTitle: 'Надіслати форму онлайн',
      formSubtitle: 'Опишіть ваші потреби, і ми відповімо протягом 24 годин.',
      enquiry: 'Надіслати запит',
      callTitle: 'Зателефонуйте нам',
      callSubtitle: 'Поговоріть напряму з нашою багатомовною командою.',
    },
    sections: {
      manufacturers: 'Виробники',
      quickLinks: 'Швидкі посилання',
      connect: 'Контакти',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Усі права захищені',
      privacy: 'Політика конфіденційності',
      terms: 'Умови користування',
    },
    recaptcha: 'Захищено reCAPTCHA',
    recaptchaPrivacy: 'Конфіденційність',
    recaptchaTerms: 'Умови',
    disclaimer:
      'GMG Automation не є офіційним дистриб’ютором або уповноваженим представником виробників, згаданих на цьому сайті. Зареєстровані торгові марки та назви, згадані на цьому сайті, належать їхнім відповідним власникам.',
  },

  common: {
    noResults: 'Нічого не знайдено',
  },

  validation: {
    required: "Це поле є обов'язковим",
    emailInvalid: 'Будь ласка, введіть коректну електронну адресу',
    tooLong: 'Це поле не може перевищувати {max} символів',
    recaptchaError: 'Не вдалося пройти перевірку reCAPTCHA. Будь ласка, спробуйте ще раз.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Запасні частини для промислової автоматизації',
      description: 'Знаходьте застарілі та актуальні запасні частини для промислової автоматизації. Шукайте за номером деталі та надсилайте запит протягом 24 годин. Контролери, ПЛК, HMI-панелі, сервоприводи та інше.',
    },
    manufacturers: {
      title: 'Виробники — GMG Automation',
      description: 'Переглядайте запасні частини для автоматизації за виробниками. Siemens, ABB, Schneider Electric, Fanuc та сотні інших. Швидка доставка по всьому світу з гарантією 12 місяців.',
    },
    about: {
      title: 'Про нас — GMG Automation',
      description: 'Понад 10 років досвіду у постачанні запасних частин для промислової автоматизації. Багатомовна команда, глобальна мережа постачальників, швидка відповідь і гарантія 12 місяців на всі деталі.',
    },
    blog: {
      title: 'Блог — GMG Automation',
      description: 'Будьте в курсі останніх новин, галузевих матеріалів та технічних статей від команди GMG Automation.',
    },
    faq: {
      title: 'Часті запитання — GMG Automation',
      description: 'Відповіді на поширені запитання щодо замовлень, доставки, оплати та гарантії у GMG Automation.',
    },
    contact: {
      title: "Зв'яжіться з нами — GMG Automation",
      description: "Зв'яжіться з командою GMG Automation. Зателефонуйте нам, надішліть форму або напишіть нам напряму. Відповідаємо протягом 24 годин.",
    },
    terms: {
      title: 'Умови користування — GMG Automation',
      description: 'Ознайомтеся з умовами користування послугами GMG Automation та придбання промислових запасних частин.',
    },
    privacy: {
      title: 'Політика конфіденційності — GMG Automation',
      description: 'Дізнайтеся, як GMG Automation збирає, використовує та захищає ваші особисті дані відповідно до чинного законодавства про захист персональних даних.',
    },
    cookie: {
      title: 'Політика Cookie — GMG Automation',
      description: 'Дізнайтеся про файли cookie, що використовуються на сайті GMG Automation, і як керувати своїми налаштуваннями.',
    },
    product: {
      description: 'Придбайте {partNumber} від {manufacturer}. Надішліть запит для швидкої доставки по всьому світу. Гарантія 12 місяців включена.',
    },
    manufacturerProducts: {
      description: 'Переглядайте запасні частини та компоненти автоматизації {manufacturer}. Шукайте за номером деталі та надсилайте запит для швидкої доставки.',
    },
  },
}
